import { DraftLine } from './types';

// Поле «Исполнители» вида замены масла — «управляемое множество»
// (OilChangePage.md §3Г п.4, rev. 2026-09-10 №5):
// - из каждой заполненной строки услуг удаляются ТОЛЬКО исполнители,
//   которые поле показывало при открытии (managedOldIds);
// - в освободившиеся слоты executor1/2/3 вписывается текущее поле (в его порядке);
// - сторонние исполнители строки (по-строчно из полного вида ЗН) сохраняются,
//   пока хватает слотов (максимум 3 — приоритет у экипажа поста);
// - пустое поле (fieldIds = []) очищает управляемых исполнителей.
export const applyOilChangeExecutors = (
  services: DraftLine[],
  fieldIds: string[],
  managedOldIds: string[],
  nameOf: (id: string) => string | null,
): DraftLine[] =>
  services.map(l => {
    if (!l.name.trim()) return l;
    const kept = (
      [
        [l.executor1_id, l.executor1_name],
        [l.executor2_id, l.executor2_name],
        [l.executor3_id, l.executor3_name],
      ] as [string | null | undefined, string | null | undefined][]
    ).filter((p): p is [string, string | null | undefined] =>
      !!p[0] && !managedOldIds.includes(p[0]) && !fieldIds.includes(p[0]),
    );
    const next: [string, string | null][] = [
      ...fieldIds.map((id): [string, string | null] => [id, nameOf(id)]),
      ...kept.map((p): [string, string | null] => [p[0], p[1] ?? null]),
    ].slice(0, 3);
    return {
      ...l,
      executor1_id: next[0]?.[0] ?? null, executor1_name: next[0]?.[1] ?? null,
      executor2_id: next[1]?.[0] ?? null, executor2_name: next[1]?.[1] ?? null,
      executor3_id: next[2]?.[0] ?? null, executor3_name: next[2]?.[1] ?? null,
    };
  });

// Объединение исполнителей всех строк услуг — содержимое поля при открытии заказа
export const unionServiceExecutors = (services: DraftLine[]): string[] => {
  const ids: string[] = [];
  services.forEach(l => {
    [l.executor1_id, l.executor2_id, l.executor3_id].forEach(x => {
      if (x && !ids.includes(x)) ids.push(x);
    });
  });
  return ids;
};

// Блокировка формы замены масла (OilChangePage.md §3Г п.9, rev. №6):
// заполненные строки услуг имеют РАЗНЫЕ наборы исполнителей (без учёта порядка) —
// форма такое не представляет, редактирование только через полный вид ЗН
export const hasMixedServiceExecutors = (services: DraftLine[]): boolean => {
  const sets = services
    .filter(l => l.name.trim())
    .map(l => [l.executor1_id, l.executor2_id, l.executor3_id].filter(Boolean).sort().join(','));
  return new Set(sets).size > 1;
};
